import { IntegrationTokenDelegationRoleCode, IntegrationTokenRoleCode } from './integration-token.model';

export interface TokenRoleOption {
  value: IntegrationTokenRoleCode;
  label: string;
  description?: string;
}

export const TOKEN_ROLE_OPTIONS: TokenRoleOption[] = [
  {
    value: IntegrationTokenRoleCode.Admin,
    label: 'Full access to all projects',
    description: 'Token can perform all operations on all projects and add new projects.'
  },
  {
    value: IntegrationTokenRoleCode.ReadOnly,
    label: 'Read access to all projects',
    description: 'Token can only read data from all projects. Cannot add new projects.'
  },
  {
    value: IntegrationTokenRoleCode.NoAccess,
    label: 'Custom access per project',
    description: 'Select specific projects and assign read / full access per each.'
  }
];

// Human-readable labels for the full five-role range a delegation can carry
// (used for read-only display of delegations, incl. backend-created ones).
export const DELEGATION_ROLE_LABELS: Record<IntegrationTokenDelegationRoleCode, string> = {
  [IntegrationTokenDelegationRoleCode.Owner]: 'Owner',
  [IntegrationTokenDelegationRoleCode.Admin]: 'Full access',
  [IntegrationTokenDelegationRoleCode.BasicUser]: 'Basic user',
  [IntegrationTokenDelegationRoleCode.ReadOnly]: 'Read only',
  [IntegrationTokenDelegationRoleCode.NoAccess]: 'No access'
};
